angular.module('flipto.components.common.tasks', ['flipto.core.lodash']);